import { RecursoIntegracaoEnum } from 'graphql/types.generated'

export interface IntegracaoRecursoModel {
  enum: RecursoIntegracaoEnum
  description: string
}

export const recursosIntegracao: IntegracaoRecursoModel[] = [
  {
    enum: RecursoIntegracaoEnum.RECEBIMENTO_EXTERNO_FICHAS,
    description: 'Transmissão de dados de sistemas terceiros',
  },
  {
    enum: RecursoIntegracaoEnum.REGULACAO,
    description: 'Leitura/Escrita da regulação',
  },
]

export const getDescricaoRecursoIntegracao = (recurso: RecursoIntegracaoEnum) =>
  recursosIntegracao.find((item) => item.enum === recurso)?.description
